// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__25MQt","card":"Loader_card__UtrIK"};